import React, { useEffect, useState } from 'react';
import { FaBuilding } from 'react-icons/fa';
import { authAPI, companiesAPI } from '../api/api';
import '../css/ClientSwitcher.css';

const ALL_CLIENTS = null;

const ClientSwitcher = ({ selectedClientId, onSelect }) => {
  const [clients, setClients] = useState(authAPI.getAccessibleClients());

  useEffect(() => {
    let cancelled = false;

    const loadClients = async () => {
      try {
        const data = await companiesAPI.getCompanies();
        if (!cancelled) {
          setClients(data);
        }
      } catch (error) {
        console.warn('Cégcsoport betöltése sikertelen:', error.message);
      }
    };

    loadClients();

    return () => {
      cancelled = true;
    };
  }, []);

  if (clients.length < 2) {
    return null;
  }

  const handleSelect = (clientId) => {
    authAPI.setSelectedClientId(clientId);
    onSelect(clientId);
  };

  return (
    <div className="client-switcher">
      <span className="client-switcher-label">
        <FaBuilding /> Cég:
      </span>
      <button
        type="button"
        className={`client-switcher-option${selectedClientId === ALL_CLIENTS ? ' active' : ''}`}
        onClick={() => handleSelect(ALL_CLIENTS)}
      >
        Összes cég
      </button>
      {clients.map(client => (
        <button
          key={client.id}
          type="button"
          className={`client-switcher-option${selectedClientId === client.id ? ' active' : ''}`}
          onClick={() => handleSelect(client.id)}
          title={client.full_name || client.name}
        >
          {client.short_name || client.name}
          <span className="client-switcher-tax">{client.identifier || client.taxpayer_id || ''}</span>
        </button>
      ))}
    </div>
  );
};

export default ClientSwitcher;
